// SPDX-License-Identifier: Apache-2.0

import { jsonArrayMember, jsonObject } from "typedjson";
import { MessageType, MessageTypeName } from "./messageTypes";
import PerunMessage from "./PerunMessage";
import SignedState from "./SignedState";

@jsonObject()
export default class OpenChannelFound extends PerunMessage {
  @jsonArrayMember(SignedState)
  signedStates!: SignedState[];

  constructor(signedStates: SignedState[]) {
    super();
    this.signedStates = signedStates;
  }
  messageType(): MessageType {
    return OpenChannelFound;
  }
  messageTypeName(): MessageTypeName {
    return "OpenChannelFound";
  }
}
